<ng-container *ngIf="(applicationStateService.isApplicationLoaded() | async) else loading">

  <div class="door-list-container" [hidden]="(showFilter$ | async)">

    <app-product-type-selection *ngIf="(areProductsEnabled$ | async)" class="mb-2"
                                [selected]="(currentSelectedProductType$ | async) || 'door'"
                                (selectedChange)="setProductTypeFilter($event)"
                                [productTypes]="(productTypeFilter$ | async)!"></app-product-type-selection>

    <div class="door-toolbar" *ngIf="(currentSelectedProductType$ | async) == 'door' && (isWidgetMode$ | async) === false">

      <!-- door type selection -->
      <app-door-type-toggle
        *ngIf="currentSelectedDoorType && (isDoorTypeFilterEnabled$ | async)"
        [dropdown]="enableDoorTypeDropdown$ | async"
        [selected]="currentSelectedDoorType"
        [doorTypes]="(mainDoorTypeFilter$ | async)!"
        (onValueChanged)="setMainDoorTypeFilter($event)">
      </app-door-type-toggle>


      <div class="toggle-fav flex-shrink-0" *ngIf="(isFavoriteFeatureEnabled$ | async)">
        <input id="toggle-id" class="toggle-checkbox" type="checkbox"
               [checked]="isFavoriteFilterEnabled$ | async"
               (change)="onToggleFavoriteFilter($event)"/>
        <label class="toggle-button" for="toggle-id">
          <span class="toggle-text-on">{{ favoritesCount$ | async }}</span>
          <span class="toggle-slider"><i class="icon-toggle-off m-icon heart m-lg"></i><i
            class="icon-toggle-on m-icon heart-solid m-lg"></i></span>
          <span class="toggle-text-off">{{ favoritesCount$ | async }}</span>
        </label>
      </div>

      <button *ngIf="isFilterFeatureEnabled$ | async" class="btn btn-primary button-filter flex-shrink-0"
              (click)="onSetFilter($event)"><i
        class="m-icon filter"></i> {{ 'redesign.filterButtonText' | translate }}
      </button>

      <div class="select-sorting" *ngIf="isSortingActive$ | async">
        <select class="form-select w-auto flex-shrink-1"
                (change)="onSelectSorting($any($event.target).value)" aria-label="select sorting">
          <option value="" selected>{{ 'redesign.sorting' | translate }}</option>
          <option *ngFor="let sortingOption of sortingOptions$ | async" [value]="sortingOption.id"
                  [selected]="isSelectedSorting(sortingOption.id) | async">{{ sortingOption.name }}
          </option>
        </select>
      </div>

    </div>

    <custom-attributes-filter (onValueChanged)="onCustomAttributeFilterChanged($event)" *ngIf="(hasCustomAttributesFilter$ | async) && (isWidgetMode$ | async) === false" style="margin-bottom: 16px">

    </custom-attributes-filter>

    <ng-scrollbar class="custom-scrollbar"
                  infiniteScroll
                  visibility="hover"
                  [minThumbSize]="40"
                  appearance="standard"
                  disableInteraction="false"
                  [infiniteScrollDistance]="5"
                  [infiniteScrollThrottle]="50"
                  [scrollWindow]="false"
                  infiniteScrollContainer=".ng-scroll-viewport"
                  (scrolled)="onScroll()">

      <ng-container *ngIf="!(shouldShowNoFavorites$ | async) else noFavorites">
        <ng-container *ngIf="!(shouldShowNoProductsWarning$ | async) else noProducts">
            <div class="row door-list d-flex" *ngIf="props$ | async as props">
              <div class="door-container"
                   [class.single-door]="narrowDoorTypes.includes(product.doorType)"
                   *ngFor="let product of props.products; trackBy: productsTrackBy">

                <div class="door" [class.loading-animation]="!product.isLoaded" (click)="onProductSelected(product)"
                     [class.active]="isProductSelected(product) | async">
                  <img lazyImg [src]="product.thumbnailUrl" (load)="onProductLoaded(product)" alt="" crossorigin/>
                  <div class="door-name-container" *ngIf="product.isLoaded">
                    <p class="door-name">{{ product.name }}</p>
                  </div>

                  <!-- Favorite icon -->
                  <div class="fav-container"
                       *ngIf="(currentSelectedProductType$ | async) === 'door'  && product.isLoaded && (isFavoriteFeatureEnabled$ | async)"
                       [class.marked-as-favorite]="product.isFavorite">
                    <i class="m-icon" (click)="onToggleFavorite(product, $event)" [class.heart]="!product.isFavorite"
                       [class.heart-solid]="product.isFavorite"></i>
                  </div>
                </div>
              </div>

              <!-- Loading animation -->
              <ng-container *ngIf="doorService.showNextPageLoadingIndicator()">
                <div class="col-6 col-lg-4 col-xxl-3 door-container"
                     *ngFor="let i of getArrayOfLoadingDoorsForProgress()">
                  <div class="door loading-animation">
                    <div class="loading-door">
                      <div class="loading-image"></div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
        </ng-container>
      </ng-container>

      <ng-template #noFavorites>
        <p class="no-favorites-title">{{ 'redesign.noFavorites.title' | translate }}</p>
        <p class="no-favorites-description">{{ 'redesign.noFavorites.description' | translate }}</p>
        <button class="btn btn-primary" (click)="doToggleShowFavorites(false)"><i
          class="m-icon arrow-forward"></i>{{ 'redesign.noFavorites.buttonText' | translate }}
        </button>
      </ng-template>

      <ng-template #noProducts>
        <p
          class="no-favorites-title">{{ 'redesign.noProducts.title' | translate: { productType: translatedCurrentlySelectedProductType$ | async } }}</p>
        <p
          class="no-favorites-description">{{ 'redesign.noProducts.description' | translate: { productType: translatedCurrentlySelectedProductType$ | async } }}</p>
        <button class="btn btn-primary" (click)="setProductTypeFilter('door')"><i
          class="m-icon arrow-forward"></i>{{ 'redesign.noProducts.buttonText' | translate: { productType: translatedCurrentlySelectedProductType$ | async } }}
        </button>
      </ng-template>

    </ng-scrollbar>
    <div class="doors-loading" *ngIf="showDoorLoadingIndicator$ | async">
      <div class="spinner-border text-primary" style="width: 60px; height: 60px" role="status">
      </div>
    </div>
  </div>

  <app-filter [hidden]="!(showFilter$ | async)"></app-filter>
</ng-container>

<!-- loading indicator -->
<ng-template #loading>
  <div class="door-toolbar">
    <div class="loading-button loading-animation"></div>
    <div class="loading-button loading-animation"></div>
  </div>
  <div class="row door-list d-flex is-loading">
    <div class="col-6 col-lg-4 col-xxl-3 door-container" *ngFor="let i of getArrayOfLoadingDoors()">
      <div class="door loading-animation">
        <div class="loading-door">
          <div class="loading-image"></div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
